import { useLanguageResource } from "@ruter-as/web-components-and-tools";
import type React from "react";
import type { InitErrorType } from "../../types/InitError";
import errorLanguageResource from "./lang-resource";

interface Props {
	error: InitErrorType;
	missingUsblParams?: string[];
}

const InitError: React.FC<Props> = ({ error, missingUsblParams }) => {
	const lang = useLanguageResource(errorLanguageResource);
	return (
		<div className="init-error">
			<h3>{lang.initError.title}</h3>
			<div className="reason">
				{error === "ERROR_REASON_SERVER_ERROR" && (
					<div data-test-id="server-error">{`${lang.initError.reason}: ${lang.initError.serverError}`}</div>
				)}
				{error === "ERROR_REASON_MISSING_SECRET" && (
					<div data-test-id="missing-secret">{`${lang.initError.reason}: ${lang.initError.missingKey}`}</div>
				)}
				{error === "ERROR_REASON_MISSING_CLIENTID" && (
					<div data-test-id="missing-id">{`${lang.initError.reason}: ${lang.initError.missingUserName}`}</div>
				)}
				{error === "ERROR_REASON_INCOMPLETE_USBL_PARAMS" && (
					<div data-test-id="incomplete-usbl-params">
						<span>{`${lang.initError.reason}: ${lang.initError.incompleteUsblParams}`}</span>
						{missingUsblParams && missingUsblParams.length > 0 && (
							<span data-test-id="missing-usbl-params-list">{` (mangler: ${missingUsblParams.join(", ")})`}</span>
						)}
					</div>
				)}
			</div>
		</div>
	);
};
export default InitError;
